import React from 'react'
import PropTypes from 'prop-types'
import CountUp from 'react-countup'
import Format from 'src/Components/Format'
import Text from 'src/Components/Text'
import usePrev from 'src/hooks/usePrev'

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.number.isRequired
}

const Savings = ({ children, caution, ...restProps }) => {
  const prevChildren = usePrev(children)

  let color = 'red'
  if (children > 0) {
    color = 'green'
    if (caution) {
      color = 'orange'
    }
  }

  return (
    <Text element='div' size='xxl' weight='light' color={color} {...restProps}>
      <CountUp
        start={prevChildren}
        end={children}
        formattingFn={Format.currency}
      />
    </Text>
  )
}

Savings.propTypes = propTypes

export default Savings
